import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { capitalizeAndReplace } from "../../../utils/common";
import { ListingScroll } from "./List";
import MetaTags from "../../common/MetaTags";
import {
  updateFilterModalDate,
  updateFilterModalIsland,
  updateFilterModalLocation,
  updateFilterModalMerchant,
  updateFilterModalSub,
  updateListingLastPage,
  updateListingLoading,
  updateListingPage,
  updateListings,
  updateMultipleFields,
} from "../../../store/slicers/listingSlice";
import Helmet from "react-helmet";
const Listing = () => {
  const location = useLocation();
  const pathnameParts = location.pathname.split("/");
  const serviceTypeName = pathnameParts[pathnameParts.length - 1];
  const dispatch = useDispatch();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const place = queryParams.get("location");
  const merchant = queryParams.get("merchant");
  const date = queryParams.get("date");
  const island = queryParams.get("island");

  const [sub, setSelectedSub] = useState("");

  const filters = [
    { icon: "allevent", name: "Any Event" },
    { icon: "anniversary", name: "Anniversary" },
    { icon: "bachelor", name: "Bachelor" },
    { icon: "bbq", name: "BBQ" },
    { icon: "birthday", name: "Birthday" },
    { icon: "christening", name: "Christening" },
    { icon: "corporate", name: "Corporate" },
    { icon: "pool", name: "Pool" },
    { icon: "reunion", name: "Reunion" },
    { icon: "wedding", name: "Wedding" },
  ];

  const handleSub = (str) => {
    if (str !== sub && str !== "allevent") {
      updateState(str);
    } else if (str === "allevent" && sub !== "") {
      updateState("");
    }
  };

  const updateState = (str) => {
    dispatch(updateListingLoading(false));
    dispatch(updateListingLastPage(false));
    dispatch(updateListings([]));
    dispatch(updateListingPage("1"));
    setSelectedSub(str);
    dispatch(updateFilterModalSub(str));
  };
  useEffect(() => {
    dispatch(
      updateMultipleFields({
        selectedDate: {
          startDate: "",
          endDate: "",
        },
        serviceCalendar: [],
        serviceOffered: [],
        servicePricing: {},
        servicePhotos: [],
        serviceReviews: [],
        eventHighlights: [],
      })
    );

    dispatch(updateFilterModalLocation(place || ""));
    dispatch(updateFilterModalMerchant(merchant || ""));
    dispatch(updateFilterModalDate(date || ""));
    dispatch(updateFilterModalIsland(island || ""));
    dispatch(updateFilterModalSub(sub || ""));
  }, []);

  return (
    <div className="flex flex-col items-center w-full">
      {/* Title */}
      <div className="text-3xl text-center font-semibold text-primary-500 mt-6">
        {capitalizeAndReplace(serviceTypeName)}
      </div>

      {/* Meta tags */}
      <Helmet>
        <MetaTags
          title={capitalizeAndReplace(serviceTypeName)}
          description={capitalizeAndReplace(serviceTypeName)}
          keywords={`${serviceTypeName} ${place} ${merchant}`}
        />
      </Helmet>

      {/* Filter Scroll */}
      <div className="w-full mt-10 overflow-x-auto  justify-items-center text-center">
        <div className="inline-flex gap-2 items-center  min-w-max">
          {filters.map((data, key) => (
            <div
              key={key}
              onClick={() => handleSub(data.icon)}
              className={`${
                sub === data.icon || (sub === "" && key === 0)
                  ? "bg-gray-50"
                  : ""
              } py-2 cursor-pointer hover:bg-gray-50 rounded-xl text-center`}
            >
              <div className="w-8 h-8 mx-auto">
                <div
                  className={`${
                    sub === data.icon || (sub === "" && key === 0)
                      ? `active-${data.icon}`
                      : data.icon
                  } w-full h-full bg-no-repeat bg-contain`}
                />
              </div>
              <div
                className={`${
                  sub === data.icon || (sub === "" && key === 0)
                    ? "text-primary-500"
                    : ""
                } mt-2 text-sm whitespace-nowrap w-24 text-center`}
              >
                {data.name}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Listings */}
      <div className="w-full my-10">
        <ListingScroll />
      </div>
    </div>
  );
};

export default Listing;
